import { render, staticRenderFns } from "./sendStrategy.vue?vue&type=template&id=51df0558&"
import script from "./sendStrategy.vue?vue&type=script&lang=js&"
export * from "./sendStrategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports